import { Theme, withStyles } from '@material-ui/core';
import { Header, HeaderConnected, LoadingIcon } from 'bc-front-sagacomponents';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimension';
import Accueil from '../../images/Accueil';
import IllustrationDroiteSvg from '../../images/illustration-droite';
import IllustrationGaucheSvg from '../../images/illustration-gauche';
import { RootState } from '../../redux/reducers';
import { getPersonnalisationPart } from '../../redux/ReferentielRedux';
import { PersonnalisationClient } from '../../services/Api/swagger';
import { logout } from '../../services/Authentification/authentification';
import history from '../../services/history';
import CustomThemeProvider from '../CustomThemeProvider';
import MobileHeader from '../MobileHeader';
import styles from './styles';
import { getAxeptioCookieManager, getMatomoAnalyticsManager } from '../../services/Config';
import AxeptioInjector from '../../axeptio.injector';
import MetaDatas from '../MetaDatas';

interface Props {
  passTheme?: (arg0: Theme) => void;
  children: any;
  classes?: any;
  hideConnectionBtn?: boolean;
  authenticated?: boolean;
  noHeader?: boolean;
}

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;

const Layout = (props: Props) => {
  const { children, classes, authenticated, noHeader, hideConnectionBtn } = props;

  const personnalisation = useReduxSelector<PersonnalisationClient>((state) => getPersonnalisationPart(state));

  const menuResponsive = useReduxSelector((state) => state.global.menu);

  // GESTION ILLUSTRATION
  let classGauche = classes.illu;
  let classDroite = classes.illu;
  if (window.location.pathname === '/accueil') {
    classGauche += ' ' + classes.illuGaucheHome;
  } else {
    classGauche += ' ' + classes.illuGauche;
  }
  if (window.location.pathname === '/') {
    classDroite += ' ' + classes.illuDroiteHome;
  } else {
    classDroite += ' ' + classes.illuDroite;
  }

  // GESTION CLASSNAME
  let classSection =
    window.location.pathname === '/accueil' || window.location.pathname === '/' ? 'sectionAccueil' : '';

  if (noHeader) {
    classSection += ' ' + classes.noHeader;
  }

  // Header
  let menuHeader = [
    {
      id: 'accueil',
      value: 'Accueil',
      link: () => history.push('/accueil'),
      icon: <Accueil />,
    },
  ];

  const menuPopoverHeader = [
    {
      id: 'deconnexion',
      value: 'Déconnexion',
      link: () => logout(),
    },
  ];

  // Get Theme from child component : CustomThemeProvider
  const [theme, setTheme] = useState<Theme>();
  useEffect(() => {
    if (props.passTheme) {
      if (theme) {
        props.passTheme(theme);
      }
    }
  }, [props, theme]);

  const { width } = useWindowDimensions();

  const tokenParsed = localStorage.getItem('token');
  const offline = useReduxSelector((state) => state.global.offline);

  const displayHeaderConnected = (authenticated && !noHeader) || (tokenParsed && offline && !noHeader);
  const displayHeader = (!authenticated && !noHeader) || (!tokenParsed && offline && !noHeader);

  const clientId = getAxeptioCookieManager();
  const matomoInstance = getMatomoAnalyticsManager();
  AxeptioInjector(clientId);

  if (width) {
    return (
      <>
        <MetaDatas matomoTag={matomoInstance} />
        <CustomThemeProvider setTheme={setTheme}>
          {displayHeaderConnected && (
            <>
              {personnalisation && personnalisation.personnalisation?.images.logo ? (
                <HeaderConnected
                  menuHeader={menuHeader}
                  menuPopoverHeader={menuPopoverHeader}
                  lienAccueil={() => history.push('/accueil')}
                  contactLink={() => history.push('/contact')}
                  activeContactLink={window.location.pathname === '/contact'}
                  mobileHeader={width <= 628}
                  logoFile={personnalisation.personnalisation.images.logo}
                />
              ) : (
                <HeaderConnected
                  menuHeader={menuHeader}
                  menuPopoverHeader={menuPopoverHeader}
                  lienAccueil={() => history.push('/accueil')}
                  contactLink={() => history.push('/contact')}
                  activeContactLink={window.location.pathname === '/contact'}
                  mobileHeader={width <= 628}
                />
              )}
            </>
          )}
          {displayHeader && (
            <Header
              lienAccueil={() => history.push('/accueil')}
              contactLink={() => history.push('/contact')}
              activeContactLink={window.location.pathname === '/contact'}
              hideConnectionBtn={hideConnectionBtn}
            />
          )}
          <section className={classSection}>
            {window.location.pathname !== '/' && (
              <>
                {window.location.pathname === '/mentions-legales' ||
                window.location.pathname === '/donnees-personnelles' ? (
                  <div className={classGauche}>
                    <IllustrationGaucheSvg></IllustrationGaucheSvg>
                  </div>
                ) : (
                  <div className={classGauche}>
                    <IllustrationGaucheSvg color={theme ? theme.palette.secondary.main : ''}></IllustrationGaucheSvg>
                  </div>
                )}{' '}
              </>
            )}
            {window.location.pathname !== '/accueil' && width > 628 && (
              <>
                {window.location.pathname === '/' ||
                window.location.pathname === '/mentions-legales' ||
                window.location.pathname === '/donnees-personnelles' ? (
                  <div className={classDroite}>
                    <IllustrationDroiteSvg></IllustrationDroiteSvg>
                  </div>
                ) : (
                  <div className={classDroite}>
                    <IllustrationDroiteSvg
                      color1={theme ? theme.palette.secondary.main : ''}
                      color2={theme ? theme.palette.secondary.light : ''}
                    ></IllustrationDroiteSvg>
                  </div>
                )}
              </>
            )}
            {width <= 628 && (authenticated || (tokenParsed && offline)) && (
              <MobileHeader menuResponsive={menuResponsive} />
            )}
            {children}
          </section>
        </CustomThemeProvider>
      </>
    );
  } else return <LoadingIcon />;
};
export default withStyles(styles)(Layout);
